import { createFileRoute } from '@tanstack/react-router'
import { FormReviewQueuePage } from '@/features/forms/review/review-queue'

export const Route = createFileRoute(
  '/_authenticated/_organization/forms/review-queue',
)({
  component: FormReviewQueuePage,
})
